import React from '../../vendor/react';
import { useEffect, useState } from '../../vendor/react';
import { KeyRound } from '../../vendor/lucide-react';
import { currentSearch, Link, navigate } from '../../vendor/react-router-dom';
import { AuthLayout } from '../../components/auth/AuthLayout';
import { AuthNotice } from '../../components/auth/AuthNotice';
import { useAuth } from '../../features/auth/auth-store';

export function MagicLinkPage() {
  const auth = useAuth();
  const [error, setError] = useState('');
  const token = new URLSearchParams(currentSearch()).get('token') ?? '';
  useEffect(() => {
    if (!token) return setError('El enlace no contiene un token válido.');
    auth.actions.consumeMagicLink(token)
      .then(() => navigate(auth.workspace?.onboardingComplete ? '/app' : '/onboarding', { replace: true }))
      .catch((reason) => setError(reason instanceof Error ? reason.message : 'No se pudo utilizar el enlace.'));
  }, [token]);
  return (
    <AuthLayout eyebrow="Enlace mágico" title="Validando tu acceso" description="El enlace se está comprobando y se invalidará después de usarse.">
      <div className="auth-confirmation-icon"><KeyRound size={30} /></div>
      {error ? <AuthNotice tone="error">{error}</AuthNotice> : <div className="auth-inline-loading"><span className="loading-spinner" /><p>Abriendo tu sesión…</p></div>}
      {error && <p className="auth-card__footer"><Link to="/ingresar">Solicitar otro enlace</Link></p>}
    </AuthLayout>
  );
}
